<template>
  <HomeSearch v-if="searchQuery" />
  <PageGlobal v-else-if="preview"/>
  <HomeIndex v-else />
</template>

<script lang="ts" setup>
import HomeIndex from '~/components/Home/Index.vue';
import HomeSearch from '~/components/Home/Search.vue';
import PageGlobal from '~/components/PageGlobal.vue';

const searchQuery = ref('');
const route = useRoute();
const router = useRouter();
const pageId = route.query.p;
const previewId = route.query.preview_id
const preview = route.query.preview;
const previewType = ref('');

if( typeof route.query.s !== 'undefined' ) {
  if (typeof route.query.s === 'string') {
    searchQuery.value = route.query.s;
  }
}

watch(
  () => route.query.s,
  (newValue) => {
    if (typeof newValue === 'string') {
      searchQuery.value = newValue;
    } else {
      searchQuery.value = '';
    }
  }
);


</script>